<div class="kb-article-container">
  <ngx-spinner bdColor="rgba(0,0,0,0.3)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="color: white">Loading...</p>
  </ngx-spinner>

  <!-- Back button -->
  <div class="mb-3">
    <button nbButton ghost size="small" (click)="goBack()">
      <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon> Back to Support
    </button>
  </div>

  <!-- Loading state -->
  <div *ngIf="loading" class="text-center py-5">
    <p class="text-muted">Loading article...</p>
  </div>

  <!-- Not found state -->
  <div *ngIf="!loading && !article" class="text-center py-5">
    <nb-icon icon="file-remove-outline" class="not-found-icon" pack="eva"></nb-icon>
    <h4>Article not found</h4>
    <p class="text-muted">The article you are looking for does not exist.</p>
  </div>

  <!-- Article content -->
  <nb-card *ngIf="!loading && article">
    <nb-card-header>
      <div class="article-header">
        <h2 class="article-title">{{ article.title }}</h2>
        <div class="article-meta mt-2">
          <span *ngIf="article.category" class="badge bg-info text-white me-1">{{ article.category }}</span>
          <span *ngFor="let tag of article.tags" class="badge bg-secondary me-1">{{ tag }}</span>
          <ng-container *ngIf="article.audience && article.audience.length > 0">
            <span *ngFor="let r of article.audience" class="badge bg-warning text-dark me-1">{{ r }}</span>
          </ng-container>
          <span *ngIf="!article.audience || article.audience.length === 0" class="badge bg-success text-white me-1">Public</span>
        </div>
        <div class="article-info mt-2">
          <small class="text-muted me-3" *ngIf="article.viewCount != null">
            <nb-icon icon="eye-outline" pack="eva"></nb-icon> {{ article.viewCount }} views
          </small>
          <small class="text-muted" *ngIf="article.updatedAt">
            Last updated: {{ formatDate(article.updatedAt) }}
          </small>
        </div>
      </div>
    </nb-card-header>

    <nb-card-body>
      <!-- Admin actions -->
      <div class="admin-actions mb-3" *ngIf="role === 'admin'">
        <button nbButton status="primary" size="small" class="me-2" (click)="onEdit()">
          <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit
        </button>
        <button nbButton status="danger" size="small" (click)="onDelete()">
          <nb-icon icon="trash-2-outline" pack="eva"></nb-icon> Delete
        </button>
      </div>

      <!-- Article body -->
      <div class="article-content" [innerHTML]="safeContent"></div>
    </nb-card-body>
  </nb-card>
</div>
